// extracted by mini-css-extract-plugin
module.exports = {"root":"NRICSettingPage_root__2Kwn6"};